import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessagebarComponent } from 'basecomponents';
import { Router, ActivatedRoute } from '@angular/router';

import { GlobalService } from '@solar/services/global.service';
import { CountryPickerService } from 'basecomponents';
import { SolarBase1Component } from '@solar/solar/solar-base/solar-base1.component';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { PanelType } from 'solar-bo';
import { ObjHelper } from 'shtools';


@Component({
  selector: 'app-paneltype-edit',
  templateUrl: './paneltype-edit.component.html'
})
export class PanelTypeEditComponent extends SolarBase1Component implements OnInit, OnChanges {

  @Output() saveEvent = new EventEmitter<PanelType>();
  @Input() panel: PanelType = new PanelType();
  @Input() ismodal: boolean = false;
  @ViewChild('frmsmessagebar') frmsmessagebar: MessagebarComponent;
  public countries: any[];
  //@ViewChild('editform') public editform: NgForm;

  public constructor(
    public dialog: MatDialog
    , public globService: GlobalService
    , public route: ActivatedRoute
    , public solarService: SolarService
    , public router: Router
    , private fb: FormBuilder
    , private countryPickerService: CountryPickerService
  ) {
    //super(dialog, globService,route,baseService,router);
    super();
    this.createForm();
  }

  ngOnInit() {
    this.setForm();
    this.loading = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log(changes);
    const typeChange = changes['panel'];
    if ((typeChange && !typeChange.firstChange) && typeChange.currentValue != undefined) {
      this.panel = typeChange.currentValue;
      this.setForm();
    }
  }

  isvalid() {
    return this.myform.valid && !this.submitted;
  }

  createForm() {
    this.myform = this.fb.group({
      brand: ['', [Validators.required, Validators.minLength(3)]],
      model: ['', [Validators.required]],
      serial: [''],
      type: ['', [Validators.required]],
      datasheet: [''],
      Imp: ['', [Validators.required]],
      Isc: ['', [Validators.required]],
      Vmp: ['', [Validators.required]],
      Voc: ['', [Validators.required]],
      power: ['', [Validators.required]],
      efficency: ['', [Validators.required]],
      dimension_H: ['', [Validators.required]],
      dimension_W: ['', [Validators.required]],
      dimension_D: ['', [Validators.required]],      
    });

  }

  setForm() {

    if (this.panel == null) {
      return;
    }

    const obj = this.panel;
    this.myform.reset({
      brand: obj.brand,
      model: obj.model,
      serial: obj.serial,
      type: obj.type,
      //datasheet: obj.info.datasheet,
      Imp: obj.electrical.Imp,
      Isc: obj.electrical.Isc,
      Vmp: obj.electrical.Vmp,
      Voc: obj.electrical.Voc,
      power: obj.electrical.power,
      efficency: obj.electrical.efficency,
      cemark:obj.certification["CE Mark"],
      dimension_W: obj.mechanical.W,
      dimension_H: obj.mechanical.H,
      dimension_D: obj.mechanical.D,
    });
  }


  prepareSave(): any {
    //como ejemplo, en nuestro caso es el mismo objeto
    const formModel = this.myform.value;
    let cloneModel: PanelType ;
    if (this.panel) {
      cloneModel=ObjHelper.cloneDeep(this.panel);
    }
    else {
      cloneModel= new PanelType();
    }

    cloneModel.name = formModel.name;
    cloneModel.brand = formModel.brand;
    cloneModel.model= formModel.model;
    cloneModel.serial= formModel.serial;
    cloneModel.type= formModel.type;
    //cloneModel.mechanical= formModel.mechanical;
    //cloneModel.info.datasheet=formModel.datasheet;
    cloneModel.electrical.Imp= formModel.Imp;
    cloneModel.electrical.Isc= formModel.Isc;
    cloneModel.electrical.Vmp= formModel.Vmp;
    cloneModel.electrical.Voc= formModel.Voc;
    cloneModel.electrical.power= formModel.power;
    cloneModel.electrical.efficency= formModel.efficency;
    cloneModel.mechanical.W= formModel.dimension_W;
    cloneModel.mechanical.H= formModel.dimension_H;
    cloneModel.mechanical.D= formModel.dimension_D;
    //cloneModel.electrical.cemark=obj.certification["CE Mark"];
    //cloneModel.Temperature:{max:number,min:number};
    //cloneModel.certification:{"CE_Mark":string,"ISO_14001":string,"UL_Listed":string};

    return cloneModel;
  }


  saveModel() {
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {

      const clonemodel = this.prepareSave();
      this.solarService.PanelTypeEditCreate(clonemodel)
        .subscribe((res) => this.savehandleresult(res), err => this.savehandleError(err)
        );
    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }
  }

  savehandleresult(resultmodel: PanelType) {
    console.log("Panel Type saved", resultmodel);
    this.submitted = false;
    this.loading = false;
    this.showmessage('Panel type saved ');

    if (this.panel == null) {
      //creando
      this.panel = resultmodel;
    }
    else {
      //editando asignamos los valores que necesitamos, porque no sabemos si el servicio devuelve todo o solo lo que interesa.
      this.panel = resultmodel;
      //si hay otros campos que necesitamos actualizar hay que añadirlos aqui

    }
    this.saveEvent.emit(this.panel);

  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.showerror("Error saving site. Message: " + err.message);
    console.error('An error occurred:', err.message);
  }

}
